import { Helmet } from 'react-helmet-async';
import Card from './Card'
import Loader from './Loader'
import { useLanguage } from '../i18n/LanguageContext'


const Cards = ({ cardsData, loadFigure }) => {
  const { t } = useLanguage()

  return (
    <section className="card_wrapper">
      <Helmet>
        <title>{t('metaHomeTitle')}</title>
        <meta
          name="description"
          content={t('metaHomeDesc')}
        />
      </Helmet>

      {loadFigure ? <div className="cards-loader" style={{gridColumn: '1 / -1'}}><Loader /></div> :
          cardsData.map((cardData) => (
          <Card key={cardData.properties.id} data={cardData.properties} />
      ))}
    </section>
  )
}


export default Cards
